import React from 'react';
import { Typography } from 'antd';
import { SharedFreeTrial } from '@prerender/prerender-shared/FE';
import { useNavigate } from 'react-router-dom';

import { ModalTemplate } from './ModalTemplate';
import { useTrial } from '../useTrial';
import { CHURN_REASONS } from '../FreeTrial';
import useTrackTrialEvent from '../useTrackTrialEvent';
import { useSuggestedPlan, useTrackBillingEvent, Api } from '~features/billing';

function DiscountModal() {
  const { freeTrialState, updateFreeTrialState } = useTrial();
  const trackEvent = useTrackTrialEvent();
  const navigate = useNavigate();
  const suggestedPlan = useSuggestedPlan();
  const trackBillingEvent = useTrackBillingEvent();
  const [sendFreeTrialDiscountEmail] = Api.useSendFreeTrialDiscountEmailMutation();

  const { DefaultDiscount } = SharedFreeTrial.Coupons;
  const open = freeTrialState.user.churnFollowupModal === CHURN_REASONS.too_expensive;

  const onCancel = () => {
    trackEvent('BannerClosed', { banner_name: 'Discount' });
    updateFreeTrialState({ scope: 'user', state: { churnFollowupModal: null } });
    updateFreeTrialState({ scope: 'company', state: { unconvertedFlowEnded: true } });
  };

  const onApplyDiscount = () => {
    trackEvent('ApplyDiscountClicked', { discount_rate: DefaultDiscount.percentage });

    sendFreeTrialDiscountEmail()
      .unwrap()
      .finally(() => {
        trackBillingEvent('UpgradeClicked', { cta_location: 'Discount Modal', cta_name: 'Apply discount' });
        updateFreeTrialState({ scope: 'user', state: { churnFollowupModal: null } });

        const oneWeekFromNow = new Date();
        oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7);
        oneWeekFromNow.setMinutes(0, 0, 0);

        updateFreeTrialState({
          scope: 'company',
          state: { unconvertedFlowEnded: true, discountAvailableUntil: oneWeekFromNow },
        });

        if (suggestedPlan) navigate(`/billing/plans?selectedPlan=${suggestedPlan.id}`);
        else navigate('/billing/plans');
      });
  };

  React.useEffect(() => {
    if (open) trackEvent('BannerShown', { banner_name: 'Discount' });
  }, [open]);

  return (
    <ModalTemplate
      open={open}
      title="Let's make this work for you"
      okText="Apply discount"
      cancelText="No thanks"
      cancelButtonProps={{ type: 'text' }}
      onCancel={onCancel}
      onOk={onApplyDiscount}
    >
      <Typography.Text>
        We understand budgets can be tight. Here’s {DefaultDiscount.percentage}% off for {DefaultDiscount.months}{' '}
        months.
      </Typography.Text>
    </ModalTemplate>
  );
}

export default DiscountModal;
